import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../store';

export type HealerBankDetailsPresentation = {
  type: string; // ACH or SWIFT
  name: string;
  surname: string;
  email: string;
  achRoutingNumber?: string; // related to ACH
  accountNumber?: string; // related to ACH
  accountType?: string; // related to ACH
  country?: string;
  city?: string;
  address?: string;
  postCode?: string;
  swiftCode?: string; // Related to SWIFT
  ibanCode?: string; // Related to SWIFT
  hasError: boolean;
  showLoader: boolean;
};

const getHealerBankDetailsState = (state: AppState) => state.healerBankDetails;

export const selectHealerBankDetailsPresentation = createSelector([getHealerBankDetailsState], (healerBankDetails) => {
  return {
    type: healerBankDetails.healerBankDetails?.type,
    name: healerBankDetails.healerBankDetails?.name,
    surname: healerBankDetails.healerBankDetails?.surname,
    email: healerBankDetails.healerBankDetails?.email,
    achRoutingNumber: healerBankDetails.healerBankDetails?.achRoutingNumber,
    accountNumber: healerBankDetails.healerBankDetails?.accountNumber,
    accountType: healerBankDetails.healerBankDetails?.accountType,
    country: healerBankDetails.healerBankDetails?.country,
    city: healerBankDetails.healerBankDetails?.city,
    address: healerBankDetails.healerBankDetails?.address,
    postCode: healerBankDetails.healerBankDetails?.postCode,
    swiftCode: healerBankDetails.healerBankDetails?.swiftCode,
    ibanCode: healerBankDetails.healerBankDetails?.ibanCode,
    hasError: healerBankDetails.loadingDataError !== undefined,
    showLoader: healerBankDetails.showLoader,
  } as HealerBankDetailsPresentation;
});

export const updateHealerBankDetailsTab = (tabValue: string) => ({
  type: 'UPDATE_HEALER_BANK_DETAILS_TAB',
  payload: tabValue,
});
